export const ERROR_CODE = {
  COMMON_ERROR_MESSAGE_BEARER_TOKEN_NEEDED:
    'COMMON_ERROR_MESSAGE_BEARER_TOKEN_NEEDED',
  JWT_INVALID_TOKEN: 'JWT_INVALID_TOKEN',
  ACCOUNT_HISTORY_NOT_FOUND_TOKEN: 'ACCOUNT_HISTORY_NOT_FOUND_TOKEN',
  ACCOUNT_INACTIVATED_ACCOUNT: 'ACCOUNT_INACTIVATED_ACCOUNT',
};
